import React, { Component, useState } from 'react'
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import { withRouter } from '../../utils/with-router'
// import Register from './Register/Register';
import { getSponsors,getPartners } from "../../fetcher";
import './Sponsorship.css'
import {Link} from "react-router-dom";
class Sponsorship extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            s_email: '',
            s_firstname:'',
            s_lastname:'',
            s_title:'',
            s_company:'',
            subject:'',
            s_message: '',
            wordCount: 0,
            errors: {},
            focusedInput: '', // 记录当前选中的输入框
            sponsorLists:[],
            partnerLists:[],
            submitted: false,
        };
    }
    componentDidMount() {
        this.fetchSponsorData();
        this.fetchPartnerData();
    }

    fetchSponsorData = async () => {
        try {
            const sponsorData = await getSponsors();
            let sponsorList=[]
            //   console.log(sponsorData)
            sponsorData.records.forEach((sponsorContentElement, index) => {
                const sponsor = sponsorData.records[index].fields;
                let id = index
                let photo = sponsor.Logo[0].url
                let sponsorDetail = {id:id, photo: photo}
                // console.log(id)
                // console.log(photo)
                sponsorList.push(sponsorDetail)
                // console.log(sponsorDetail)
                // console.log(sponsorList)
            });

            this.setState({sponsorLists:sponsorList})
            //   console.log(sponsorLists)

        } catch (error) {
            console.error(error);
        }
    };
    fetchPartnerData = async () => {
        try {
            const partnerData = await getPartners();
            let partnerList=[]
            //   console.log(partnerData)
            partnerData.records.forEach((partnerContentElement, index) => {
                const partner = partnerData.records[index].fields;
                let id = index
                let photo = partner.Logo[0].url
                let partnerDetail = {id:id, photo: photo}
                // console.log(id)
                // console.log(photo)
                partnerList.push(partnerDetail)
                // console.log(partnerDetail)
                // console.log(partnerList)
            });

            this.setState({partnerLists:partnerList})
            //   console.log(partnerLists)

        } catch (error) {
            console.error(error);
        }
    };

    togglePopup = () => {
        this.setState((prevState) => ({
            isOpen: !prevState.isOpen,
            // s_email: '',
            // s_firstname:'',
            // s_lastname:'',
            // s_title:'',
            // s_company:'',
            // subject:'',
            // s_message: '',
            // wordCount: 0
        }));
    };
    handleButtonClick = () => {
        this.togglePopup();
        window.scrollTo(0, 230); // 滚动到页面顶部
    };

    clickCancel= () => {
        this.setState(() => ({
            submitted: false,
            isOpen: false,
            s_email: '',
            s_firstname:'',
            s_lastname:'',
            s_title:'',
            s_company:'',
            subject:'',
            s_message: '',
            wordCount: 0
        }));
    };


    handleInputFocus = (inputName) => {
        this.setState({
            focusedInput: inputName,
        });
    };

    handleInputBlur = () => {
        this.setState({
            focusedInput: '',
        });
    };




    handleSubmit = (e) => {
        e.preventDefault();
        
        const firstname = document.getElementById('s_firstname').value;
        const lastname = document.getElementById('s_lastname').value;
        const email = document.getElementById('s_email').value;
        const title = document.getElementById('s_title').value;
        const company = document.getElementById('s_company').value;
        const message = document.getElementById('s_message').value;
        function isValidName(name){
            const pattern = /^[a-zA-Z\s]+$/;
            return pattern.test(name);
        }
    
        function isValidEmail(email){
            const pattern = /\S+@\S+\.\S+/;
            return pattern.test(email);
        }
    
        function isValidTitle(title){
            const pattern = /^[a-zA-Z0-9\s]+$/;
            return pattern.test(title);
        }
    
        function isValidCompany(company) {
            const pattern = /^[a-zA-Z0-9\s]+$/;
            return pattern.test(company);
        }
        function displayErrorMessage(errorId, errorMessage) {
            const errorElement = document.getElementById(errorId);
            if (errorElement) {
                errorElement.innerHTML = `<span class="error-icon"></span> ${errorMessage}`;

            }
        }

        function resetErrorMessages() {
            const errorElements = document.querySelectorAll('.c-error-message,.c-error-message2');
            errorElements.forEach((errorElement) => {
                errorElement.textContent = '';
            });

        }
    
        if (!isValidName(firstname) ||!isValidName(lastname)|| !isValidTitle(title) || !isValidCompany(company) || !isValidEmail(email)||firstname===""||lastname===""||title===""||company===""||email===""||message ==""){
            console.log("can't submit")
            if(!isValidName(firstname)||firstname===''){
                const inputElement = document.getElementById('s_firstname');
                if(inputElement) {
                    if (firstname === '') {
                        displayErrorMessage('s-first-name-error', 'Please enter your firstname');
                        const labelElement = document.querySelector('label[for="s_firstname"]');
                        if (labelElement) {
                            labelElement.classList.add('s_error');
                        }
                        inputElement.classList.add('s_error_input');

                    } else if (!isValidName(firstname)) {
                        displayErrorMessage('s-first-name-error', 'Invalid Name');
                        const labelElement = document.querySelector('label[for="s_firstname"]');
                        if (labelElement) {
                            labelElement.classList.add('s_error');
                        }
                        inputElement.classList.add('s_error_input');

                    } else {
                        resetErrorMessages('s-first-name-error');
                        const labelElement = document.querySelector('label[for="s_firstname"]');
                        if (labelElement) {
                            labelElement.classList.remove('s_error');
                        }
                        inputElement.classList.remove('s_error_input');

                    }
                }
            }

            else if(!isValidName(lastname)||lastname===''){
                const inputElement = document.getElementById('s_lastname');
                if(inputElement){
                    if (lastname=== '') {
                        displayErrorMessage('s-last-name-error', 'Please enter your lastname');
                        const labelElement = document.querySelector('label[for="s_lastname"]');
                        if (labelElement) {
                            labelElement.classList.add('s_error');
                        }
                        inputElement.classList.add('s_error_input');
                    } else if (!isValidName(lastname)) {
                        displayErrorMessage('s-last-name-error', 'Invalid Name');
                        const labelElement = document.querySelector('label[for="s_lastname"]');
                        if (labelElement) {
                            labelElement.classList.add('s_error');
                        }
                        inputElement.classList.add('s_error_input');
                    } else {
                        resetErrorMessages('s-last-name-error');
                        const labelElement = document.querySelector('label[for="s_lastname"]');
                        if (labelElement) {
                            labelElement.classList.remove('s_error');
                        }
                        inputElement.classList.remove('s_error_input');
                    }
                }
            }

            else if(!isValidEmail(email)||email===''){
                const inputElement = document.getElementById('s_email');
                if (inputElement) {
                    if (email==='') {
                        displayErrorMessage('s-email-error', 'Please enter your email address');
                        const labelElement = document.querySelector('label[for="s_email"]');
                        if (labelElement) {
                            labelElement.classList.add('s_error');
                        }
                        inputElement.classList.add('s_error_input');
                    } else if (!isValidEmail(email)) {
                        displayErrorMessage('s-email-error', 'Invalid Email Address');
                        const labelElement = document.querySelector('label[for="s_email"]');
                        if (labelElement) {
                            labelElement.classList.add('s_error');
                        }
                        inputElement.classList.add('s_error_input');
                    } else {
                        resetErrorMessages('s-email-error');
                        const labelElement = document.querySelector('label[for="s_email"]');
                        if (labelElement) {
                            labelElement.classList.remove('s_error');
                        }
                        inputElement.classList.remove('s_error_input');
                    }
                }

            }

            else if(!isValidTitle(title)||title===''){
                const inputElement = document.getElementById('s_title');
                if(inputElement) {
                    if (title==='') {
                        displayErrorMessage('s-title-error', 'Please enter your title');
                        const labelElement = document.querySelector('label[for="s_title"]');
                        if (labelElement) {
                            labelElement.classList.add('s_error');
                        }
                        inputElement.classList.add('s_error_input');
                    } else if (!isValidTitle(title)) {
                        displayErrorMessage('s-title-error', 'Invalid Title');
                        const labelElement = document.querySelector('label[for="s_title"]');
                        if (labelElement) {
                            labelElement.classList.add('s_error');
                        }
                        inputElement.classList.add('s_error_input');
                    } else {
                        resetErrorMessages('s-title-error');
                        const labelElement = document.querySelector('label[for="s_title"]');
                        if (labelElement) {
                            labelElement.classList.remove('s_error');
                        }
                        inputElement.classList.remove('s_error_input');
                    }
                }
            }

            else if(!isValidCompany(company)||company===''){
                const inputElement = document.getElementById('s_company');
                if(inputElement) {
                    if (company==='') {
                        displayErrorMessage('s-company-error', 'Please enter your company');
                        const labelElement = document.querySelector('label[for="s_company"]');
                        if (labelElement) {
                            labelElement.classList.add('s_error');
                        }
                        inputElement.classList.add('s_error_input');
                    } else if (!isValidCompany(company)) {
                        displayErrorMessage('s-company-error', "Invalid Company's Name");
                        const labelElement = document.querySelector('label[for="s_company"]');
                        if (labelElement) {
                            labelElement.classList.add('s_error');
                        }
                        inputElement.classList.add('s_error_input');
                    } else {
                        resetErrorMessages('s-company-error');
                        const labelElement = document.querySelector('label[for="s_company"]');
                        if (labelElement) {
                            labelElement.classList.remove('s_error');
                        }
                        inputElement.classList.remove('s_error_input');
                    }

                }
            }
            else if(message ===''){

                displayErrorMessage('s-message-error', 'Please enter the details of your inquiry');
            }


        } else{
            var formObj1 = {
                "fields": {
                    "Firstname": firstname,
                    "Lastname": lastname,
                    "Email": email,
                    "Title": title,
                    "Company": company,
                    "Message": message
                }
            };
    
            console.log(formObj1);
    
    
            var jsonString1 = JSON.stringify(formObj1);
    
            fetch('https://api.airtable.com/v0/app4zRlCbgnEsm8Up/SponsorApplication', {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer keyzcpXsupauEJBhZ',
                    'Content-Type': 'application/json'
                },
                body: jsonString1
            })
                .then(response => response.json())
                .then(data => {})

                .catch(error => console.error('Error:', error));
    
            this.togglePopup();
    
    
            this.setState({
                s_email: '',
                s_firstname:'',
                s_lastname:'',
                s_title:'',
                s_company:'',
                subject:'',
                s_message: '',
                wordCount: 0,
                focusedInput: '',
                submitted:true,
                // sponsorLists:[],
                // partnerLists:[],
             
                errors: {},
            });
            window.scrollTo(0, 675); // 滚动到页面顶部
        }
        



    };

    
    handleInputChange = (event) => {
        function isValidName(name){
            const pattern = /^[a-zA-Z\s]+$/;
            return pattern.test(name);
        }
    
        function isValidEmail(email){
            const pattern = /\S+@\S+\.\S+/;
            return pattern.test(email);
        }
    
        function isValidTitle(title){
            const pattern = /^[a-zA-Z0-9\s]+$/;
            return pattern.test(title);
        }
    
        function isValidCompany(company) {
            const pattern = /^[a-zA-Z0-9\s]+$/;
            return pattern.test(company);
        }
    
    
        function displayErrorMessage(errorId, errorMessage) {
            const errorElement = document.getElementById(errorId);
            if (errorElement) {
                errorElement.innerHTML = `<span class="error-icon"></span> ${errorMessage}`;
            }
        }
    
    
        function resetErrorMessages() {
            const errorElements = document.querySelectorAll('.error-message,.error-message2,.error-message3,.error-message4,.error-message5,.error-message6');
            errorElements.forEach((errorElement) => {
                errorElement.textContent = '';
            });
        }



        const value = event.target.value;
        const name = event.target.name;
        let wordCount;
        let store;
        if (name === 's_message') {
            wordCount = 0;
            if (value !== 's_message'&& value !== '') {
                wordCount = this.countWords(value);
            }
        }




        this.setState({
            [name]: value,
            wordCount: wordCount,
            errors: {
                firstname: '', // Initialize or reset the error message for each field
                lastname: '',
                email: '',
                title: '',
                company: '',
                message: '',
            },
        });



        if (name === 's_firstname') {
            const inputElement = document.getElementById('s_firstname');
            if (inputElement) {
                if (value.trim() === '') {
                    displayErrorMessage('s-first-name-error', 'Please enter your first name');
                    const labelElement = document.querySelector('label[for="s_firstname"]');
                    if (labelElement) {
                        labelElement.classList.add('s_error');
                    }
                    inputElement.classList.add('s_error_input');

                } else if (!isValidName(value)) {
                    displayErrorMessage('s-first-name-error', 'Invalid name');
                    const labelElement = document.querySelector('label[for="s_firstname"]');
                    if (labelElement) {
                        labelElement.classList.add('s_error');
                    }
                    inputElement.classList.add('s_error_input');

                } else {
                    resetErrorMessages('s-first-name-error');
                    const labelElement = document.querySelector('label[for="s_firstname"]');
                    if (labelElement) {
                        labelElement.classList.remove('s_error');
                    }
                    inputElement.classList.remove('s_error_input');

                }
            }
        } else if (name === 's_lastname') {
            const inputElement = document.getElementById('s_lastname');
            if(inputElement){
                if (value.trim() === '') {
                    displayErrorMessage('s-last-name-error', 'Please enter your last name');
                    const labelElement = document.querySelector('label[for="s_lastname"]');
                    if (labelElement) {
                        labelElement.classList.add('s_error');
                    }
                    inputElement.classList.add('s_error_input');
                } else if (!isValidName(value)) {
                    displayErrorMessage('s-last-name-error', 'Invalid name');
                    const labelElement = document.querySelector('label[for="s_lastname"]');
                    if (labelElement) {
                        labelElement.classList.add('s_error');
                    }
                    inputElement.classList.add('s_error_input');
                } else {
                    resetErrorMessages('s-last-name-error');
                    const labelElement = document.querySelector('label[for="s_lastname"]');
                    if (labelElement) {
                        labelElement.classList.remove('s_error');
                    }
                    inputElement.classList.remove('s_error_input');
                }
            }
        } else if (name === 's_email') {
            const inputElement = document.getElementById('s_email');
            if (inputElement) {
                if (value.trim() === '') {
                    displayErrorMessage('s-email-error', 'Please enter your email address');
                    const labelElement = document.querySelector('label[for="s_email"]');
                    if (labelElement) {
                        labelElement.classList.add('s_error');
                    }
                    inputElement.classList.add('s_error_input');
                } else if (!isValidEmail(value)) {
                    displayErrorMessage('s-email-error', 'Invalid email address');
                    const labelElement = document.querySelector('label[for="s_email"]');
                    if (labelElement) {
                        labelElement.classList.add('s_error');
                    }
                    inputElement.classList.add('s_error_input');
                } else {
                    resetErrorMessages('s-email-error');
                    const labelElement = document.querySelector('label[for="s_email"]');
                    if (labelElement) {
                        labelElement.classList.remove('s_error');
                    }
                    inputElement.classList.remove('s_error_input');
                }
            }
        } else if (name === 's_title') {
            const inputElement = document.getElementById('s_title');
            if(inputElement) {
                if (value.trim() === '') {
                    displayErrorMessage('s-title-error', 'Please enter your title');
                    const labelElement = document.querySelector('label[for="s_title"]');
                    if (labelElement) {
                        labelElement.classList.add('s_error');
                    }
                    inputElement.classList.add('s_error_input');
                } else if (!isValidTitle(value)) {
                    displayErrorMessage('s-title-error', 'Invalid title');
                    const labelElement = document.querySelector('label[for="s_title"]');
                    if (labelElement) {
                        labelElement.classList.add('s_error');
                    }
                    inputElement.classList.add('s_error_input');
                } else {
                    resetErrorMessages('s-title-error');
                    const labelElement = document.querySelector('label[for="s_title"]');
                    if (labelElement) {
                        labelElement.classList.remove('s_error');
                    }
                    inputElement.classList.remove('s_error_input');
                }
            }
        } else if (name === 's_company') {
            const inputElement = document.getElementById('s_company');
            if(inputElement) {
                if (value.trim() === '') {
                    displayErrorMessage('s-company-error', 'Please enter your company');
                    const labelElement = document.querySelector('label[for="s_company"]');
                    if (labelElement) {
                        labelElement.classList.add('s_error');
                    }
                    inputElement.classList.add('s_error_input');
                } else if (!isValidCompany(value)) {
                    displayErrorMessage('s-company-error', "Invalid company's name");
                    const labelElement = document.querySelector('label[for="s_company"]');
                    if (labelElement) {
                        labelElement.classList.add('s_error');
                    }
                    inputElement.classList.add('s_error_input');
                } else {
                    resetErrorMessages('s-company-error');
                    const labelElement = document.querySelector('label[for="s_company"]');
                    if (labelElement) {
                        labelElement.classList.remove('s_error');
                    }
                    inputElement.classList.remove('s_error_input');
                }

            }
        

        }else if (name === 's_message' && wordCount > 300) {
            const trimmedText = value.trim();
            const words = trimmedText.split(/\s+/);
            const truncatedText = words.slice(0, 300).join(' ');
            wordCount = 300;

            this.setState({
                [name]: truncatedText,
                wordCount: wordCount,
            });

            displayErrorMessage('s-message-error', `${wordCount}/300 words!`);
        } else {
            this.setState({
                [name]: value,
                wordCount: wordCount,
            });

            resetErrorMessages('s-message-error');
        }
    }



    countWords = (text) => {
        const trimmedText = text.trim();
        if (trimmedText === "") {
            return 0;
        } else {
            const words = trimmedText.split(/\s+/);
            if (words.length> 300) {
                text= text.split(' ', 300).join(' ');
            }

            return words.length;
        }
    };







    render(){
        // const { isOpen } = this.state;
        const {
            isOpen,
            s_email,
            s_firstname,
            s_lastname,
            s_title,
            s_company,
            subject,
            s_message,
            wordCount,
            focusedInput,
            submitted
        } = this.state;

        if(isOpen) {
            document.body.classList.add('active-modal')
        } else {
            document.body.classList.remove('active-modal')
        }


        let isMobile = window.innerWidth <= 768;
        
        let SponsorList = [];
        let odd_line = [];
        let even_line = [];

        for (let i = 0; i < this.state.sponsorLists.length; i++) {
            const isOddLine = (i % 5 >= 0) && (i % 5 < 3);
            const item = this.state.sponsorLists[i];
            const content = (
                <div className='newList-one' key={`sponsor_item_${item.id}`}>
                    <div className='group_1'>
                        <div className='s_avatar_container'>
                            <div className="s_company_content" style={{ flex: 1, margin: '10px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                                <div

                                    className="s_company_logo2"
                                    style={{
                                        backgroundImage: `url(${item.photo})`,
                                        marginLeft: '10px',
                                        marginTop: '8px',
                                        width: '85%',
                                        height: '85%',
                                        backgroundSize: 'contain',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );

            // if (isOddLine === true) {
            odd_line.push(content);
            if (isMobile && odd_line.length === 2) {
                SponsorList.push(<div className='s_company_group_2' key={`sponsors${i}`}>{odd_line}</div>);
                odd_line = [];
            } else if (odd_line.length === 3) {
                SponsorList.push(<div className='s_company_group_3' key={`sponsors${i}`}>{odd_line}</div>);
                odd_line = [];
            }

        }

        // add additional line
        if (odd_line.length > 0) {
            SponsorList.push(<div className='s_company_group_3' key={`sponsors${this.state.sponsorLists.length}`}>{odd_line}</div>);
        }

        if (even_line.length > 0) {
            SponsorList.push(<div className='s_company_group_2' key={`sponsors${this.state.sponsorLists.length + 1}`}>{even_line}</div>);
        }


        let PartnerList = [];
        odd_line = [];
        even_line = [];
        for (let i = 0; i < this.state.partnerLists.length; i++) {
            const isOddLine = (i % 5 >= 0) && (i % 5 < 3);
            const item = this.state.partnerLists[i];
            const content = (
                <div className='newList-one' key={`partner_item_${item.id}`}>
                    <div className = 'group_1' >
                        <div className='s_avatar_container'>
                            <div className="s_company_content"style={{flex: 1, margin: '10px',display: 'flex', justifyContent: 'center', alignItems: 'center'  }}>
                                <div
                                    className="s_company_logo1"
                                    style={{
                                        backgroundImage: `url(${item.photo})`,
                                        marginLeft: '10px',
                                        marginTop: '8px',
                                        width: '85%',
                                        height: '85%',
                                        backgroundSize: 'contain',
                                        backgroundPosition: 'center',
                                        backgroundRepeat: 'no-repeat'
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            );

            // if (isOddLine === true) {
            odd_line.push(content);
            // if (odd_line.length === 3) {
            //     PartnerList.push(<div className='s_company_group_3' key={`partners${i}`}>{odd_line}</div>);
            //     odd_line = [];
            // }else if(isMobile ? odd_line.length === 2 : odd_line.length === 3){
            //     PartnerList.push(<div className='s_company_group_3' key={`partners${i}`}>{odd_line}</div>);
            //     odd_line = [];
            // }

            if(isMobile && odd_line.length === 2){
                PartnerList.push(<div className='s_company_group_3' key={`partners${i}`}>{odd_line}</div>);
                odd_line = [];
            }else if (odd_line.length === 3) {
                PartnerList.push(<div className='s_company_group_3' key={`partners${i}`}>{odd_line}</div>);
                odd_line = [];
            }

            // } else {
            //     even_line.push(content);
            //     if (even_line.length === 2) {
            //         PartnerList.push(<div className='s_company_group_2' key={`partners${i}`}>{even_line}</div>);
            //         even_line = [];
            //     }
            // }
        }

        // add additional line
        if (odd_line.length > 0) {
            PartnerList.push(<div className='s_company_group_3' key={this.state.partnerLists.length}>{odd_line}</div>);
        }

        if (even_line.length > 0) {
            PartnerList.push(<div className='s_company_group_2' key={`partners${this.state.sponsorLists.length + 1}`}>{even_line}</div>);
        }

        return (
            <div className='sponsor-container'>
                <h1 className='s_title'>Sponsors & Partners</h1>
                <div className='s-header'>


                    {isOpen && (
                        
                        <div className = 's-cover'>
                            
                            <div className='s-contact-header'>



                                <div className='s-contact-container'>
                                    <div className='s-newsblog-container'>

                                        <div className='s-contact_pic'>
                                            <div className='s-contact-left-header'>SVLC Sponsorship</div>
                                            <div className='s-contact-left-text'>
                                                For sponsorship inquiry, please<br/>
                                                send email to <a href="mailto:blake@svlc.tech">blake@svlc.tech</a>
                                            </div>
                                            <div className='s-contact-logo'></div>
                                        </div>
                                    </div>

                                </div>


                            </div>

                            <div className='s-contact-white-container'>
                                <form method="post"  id="s_form" autoComplete="off">
                                    <h2 className='s-contact_title'>SVLC Sponsorship Form</h2>
                                    <button className = 's-quit'onClick={this.togglePopup}></button>
                                    <div className='s-form-row'>

                                        <div className={`s-form-group ${focusedInput === 's_firstname' ? 's-focused' : ''}`}>
                                            {focusedInput !== 's_firstname' ? <div></div> : <label htmlFor="s_firstname"
                                                                                                   className={`s-fname_label ${this.state.errors.firstname ? 's-fname_error_label' : ''}`}>First Name *</label>}
                                            <input
                                                className="s-contact_box_firstname"
                                                type="s-text"
                                                id="s_firstname"
                                                name="s_firstname"
                                                value={s_firstname}
                                                onChange={this.handleInputChange}
                                                onFocus={() => this.handleInputFocus('s_firstname')}
                                                onBlur={this.handleInputBlur}
                                                required
                                                placeholder={focusedInput !== 's_firstname' ? 'First Name *' : ''}
                                                autoComplete="off"
                                            />
                                            <span id="s-first-name-error" className="error-message"></span>
                                        </div>


                                        <div className={`s-form-group ${focusedInput === 's_lastname' ? 's-focused' : ''}`}>
                                            {focusedInput !== 's_lastname' ? <div></div> : <label for="s_lastname" className='s-lname_label'>Last Name *</label>}
                                            <input
                                                className="s-contact_box_lastname"
                                                type="s-text"
                                                id="s_lastname"
                                                name="s_lastname"
                                                value={s_lastname}
                                                onChange={this.handleInputChange}
                                                onFocus={() => this.handleInputFocus('s_lastname')}
                                                onBlur={this.handleInputBlur}
                                                required
                                                placeholder={focusedInput !== 's_lastname' ? 'Last Name *' : ''}
                                                autoComplete="off"
                                            />
                                            <span id="s-last-name-error" className="error-message2"></span>

                                        </div>


                                    </div>

                                    <div className={`s-form-group ${focusedInput === 's_email' ? 's-focused' : ''}`}>
                                        {focusedInput !== 's_email' ? <div></div> : <label for="s_email"
                                                                                           className={`s-email_label ${this.state.errors.email ? 's-email_error_label' : ''}`}>Email Address *</label>}
                                        <input
                                            className="s-contact_box_email"
                                            type="s-text"
                                            id="s_email"
                                            name="s_email"
                                            value={s_email}
                                            onChange={this.handleInputChange}
                                            onFocus={() => this.handleInputFocus('s_email')}
                                            onBlur={this.handleInputBlur}
                                            required
                                            placeholder={focusedInput !== 's_email' ? 'Email Address *' : ''}
                                            autoComplete="off"
                                        />
                                        <span id="s-email-error" className="error-message3"></span>
                                    </div>


                                    <div className='s-form-row'>

                                        <div className={`s-form-group ${focusedInput === 's_title' ? 's-focused' : ''}`}>
                                            {focusedInput !== 's_title' ? <div></div> :<label for="s_title"
                                                                                              className={`s-title_label ${this.state.errors.title ? 's-title_error_label' : ''}`}>Title *</label>}
                                            <input
                                                className="s-contact_box_title"
                                                type="s-text"
                                                id="s_title"
                                                name="s_title"
                                                value={s_title}
                                                onChange={this.handleInputChange}
                                                onFocus={() => this.handleInputFocus('s_title')}
                                                onBlur={this.handleInputBlur}
                                                required
                                                placeholder={focusedInput !== 's_title' ? 'Title *' : ''}
                                                autoComplete="off"
                                            />
                                            <span id="s-title-error" className="error-message4"></span>
                                        </div>


                                        <div className={`s-form-group ${focusedInput === 's_company' ? 's-focused' : ''}`}>
                                            {focusedInput !== 's_company' ? <div></div> : <label for="s_company"
                                                                                                 className={`s-company_label ${this.state.errors.company ? 's-company_error_label' : ''}`}>Company *</label>}
                                            <input
                                                className="s-contact_box_company"
                                                type="s-text"
                                                id="s_company"
                                                name="s_company"
                                                value={s_company}
                                                onChange={this.handleInputChange}
                                                onFocus={() => this.handleInputFocus('s_company')}
                                                onBlur={this.handleInputBlur}
                                                required
                                                placeholder={focusedInput !== 's_company' ? 'Company *' : ''}
                                                autoComplete="off"
                                            />
                                            <span id="s-company-error" className="error-message5"></span>
                                        </div>
                                    </div>
                    <div className={`s-form-group ${focusedInput === 's_message' ? 's-focused' : ''}`}>
                       <textarea
                           name="s_message"
                           id="s_message"
                           value={s_message}
                           className="s-contact_box_message"
                           onChange={this.handleInputChange}
                           onFocus={() => this.handleInputFocus('s_message')}
                           onBlur={this.handleInputBlur}
                           placeholder={focusedInput !== 's_message' ? 'Is there anything else we should know about you?' : ''}
                       ></textarea> <label id="wordCount_">{wordCount}/300</label>
                                        <span id="s-message-error" className="error-message6"></span>
                                    </div>
                                    <div className = "button-container">
                                    <button className='s-contact_more_button'  onClick = {this.handleSubmit}
                                    >Submit
                                    </button>
                                    </div>
                                    <div className = "svlc-container">
                                        <div className = "svlc-logo-pic"></div>
                                    </div>
                                </form>
                                
                            </div>

                        </div>
                    )}
                    
                    {submitted && 
                            <div className = 's-notice-cover'>
                                <div className='s-notice_pic'>
                                    
                                    <div className='s-notice-text'>
                                        You have successfully submitted a sponsor application!
                                    </div>
                                    <button className='s-notice-logo' onClick = {this.clickCancel}>close</button>
                                </div>
                          
                            </div>}
                    <div className='s-container'>
                        <div className="centered-container">
                            <div className='s-photo'>

                                <li className="s-about_carousel_content">

                                    <div className='s_carousel_text'>
                                        <h2 className='s_carousel_title'>SVLC Sponsorship</h2>
                                        <p className='s_carousel_content'>SVLC’s sponsorship opportunities elevate your company's visibility, brand, and thought leadership throughout the conference. <br></br><br></br>
                                            Sponsorships also help drive additional traffic to your booth.Our goal is to provide creative sponsorship options which meet your needs and <span className="s_carousel_color">provide a solid return on your investment.</span> To assist with this, we offer numerous levels of sponsorship opportunities with varied price points to meet your budgeting needs.</p>
                                    </div>
                                    <div className="s_carousel_pic" alt="pic" />

                                </li>
                                <button  id ="register" className='s_more_button' onClick={this.handleButtonClick}>Become a Sponsor <img className='s-arrow' alt="pic" /></button>

                            </div>
                        </div>
                        <div className='s-box-container1'>
                            <div className="s_title1">Meet Our Sponsors</div>
                            {SponsorList}
                            
                        </div>

                        <div className='s-box-container2'>
                            <div className="s_title2">We Work With The Best Partners</div>
                            {PartnerList}
                            
                        </div>
                        <button id ="register" className='s_more_button2' onClick={this.handleButtonClick}> Become a Sponsor <img className='s-arrow' alt="pic" /></button>

                    </div>

                </div>
                {/* <h1 className='s_title'>Sponsors & Partners</h1> */}
                <div className='s-white-container'>

                </div>

            </div>

        )
    }
}

export default withRouter(Sponsorship);